import { render, staticRenderFns } from "./myOrderDetails.vue?vue&type=template&id=6d576134&scoped=true"
import script from "./myOrderDetails.vue?vue&type=script&lang=js"
export * from "./myOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./myOrderDetails.vue?vue&type=style&index=0&id=6d576134&prod&scoped=true&lang=css"
import style1 from "./myOrderDetails.vue?vue&type=style&index=1&id=6d576134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d576134",
  null
  
)

export default component.exports